import { toast } from 'material-react-toastify';

import { hubApi, withAuthHeader } from '@/lib/backend/api';
import { getAuthToken } from '@/lib/firebase/token';
import { tariffKeys } from '@/lib/query/keys/tariff';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { TariffType } from './useTariffs';

export const useSyncTariffs = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      const token = await getAuthToken();
      return hubApi.syncSubscriptionsTariffsLTV(withAuthHeader(token));
    },

    onMutate: async () => {
      await queryClient.invalidateQueries({ queryKey: tariffKeys.type(TariffType.Subscription) });
      toast.success('Tariffs LTV synced successfully');
    },

    onError: (err) => {
      Sentry.captureException(`Failed to sync tariffs: ${err.message}`);
      toast.error(err.message);
    },
  });
};
